import React from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import { arraysEqual } from 'helpers/utils'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";



export const TableExpandedForFinals = React.memo((props) => {
    const { row: res, config } = props;
    const adjustByTotalTime = 1;
    const { gates, splits, totalGates, colsExtendedVisible, cumulatedColsExtendedVisible } = getConfigData(config, adjustByTotalTime)
    const { breakPoint } = useViewport();
    const showNavBar = breakPoint === "sm" || breakPoint === "xs"

    return (<RunResults
        gates={gates}
        splits={splits}
        totalGates={totalGates}
        colsExtendedVisible={colsExtendedVisible}
        cumulatedColsExtendedVisible={cumulatedColsExtendedVisible}
        row={res}
        heat="F"
        adjustByTotalTime={adjustByTotalTime}
        showNavBar={showNavBar} />)

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    //return false;
    return arraysEqual(prevProps?.res?.extendedResults, nextProps?.res?.extendedResults);
});



export const TableExpandedForHeats = React.memo((props) => {
    const { row, config, heat1Data, heat2Data, heat } = props;
    const adjustByTotalTime = 1;
    const { gates, splits, totalGates, colsExtendedVisible, cumulatedColsExtendedVisible } = getConfigData(config, adjustByTotalTime)
    const { breakPoint } = useViewport();
    const showNavBar = breakPoint === "sm" || breakPoint === "xs"


    return (<>
        <RunResults
            gates={gates}
            totalGates={totalGates}
            splits={splits}
            row={row}
            heatData={heat === '1' ? heat1Data : heat2Data }
            heat={heat}
            adjustByTotalTime={adjustByTotalTime}
            showNavBar={showNavBar}
            colsExtendedVisible={colsExtendedVisible}
            cumulatedColsExtendedVisible={cumulatedColsExtendedVisible} />

    </>);

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    //return false;
    return arraysEqual(prevProps?.row?.extendedResults, nextProps?.row?.extendedResults)
});


const RunResults = (props) => {
    const { gates, totalGates, splits, row, heatData, heat, adjustByTotalTime, showNavBar, colsExtendedVisible, cumulatedColsExtendedVisible } = props;
    const getRes = () => {
        let res;
        if (heat === 'F') {
            res = row;
        } else {
            res = heatData?.results?.items?.find(item => item?.participant?.code === row?.participant?.code);
        }
        return res
    }
    let res = getRes()
    const [columnindex, setColumnIndex] = useState(getsplitByPty(cumulatedColsExtendedVisible, res));
    const [displayArr, setDisplayArr] = useState(['d-table-cell'], ...Array(totalGates + adjustByTotalTime).fill('d-table-cell'));

    useEffect(() => {
        let array_ = ['d-table-cell']
        if (!showNavBar) {
            array_ = [...array_, ...Array(Number(totalGates + adjustByTotalTime)).fill('d-table-cell')]
        } else {
            colsExtendedVisible.forEach((item, i) => {
                if (i === columnindex - 1) {
                    array_ = [...array_, ...Array(Number(item)).fill('d-table-cell')]
                } else {
                    array_ = [...array_, ...Array(Number(item)).fill('d-none')]
                }
            })
        }
        setDisplayArr(array_);
    }, [showNavBar, columnindex])

    useEffect(() => {
        setColumnIndex(getsplitByPty(cumulatedColsExtendedVisible, res));
    }, [res])


    const time = res?.eventUnitEntries?.find(eui => eui?.eue_code === 'START_TIME')?.eue_value;

    const gateNumbers = <>{
        gates?.map(gate => (<td className={`border text-center fw-bold ${displayArr[Number(gate?.pos)]}`} key={gate?.pos} >{gate?.pos}</td>))
    }</>

    const gatePenalties = <>{
        gates?.map(gate => {
            const pty = res?.extendedResults?.find(er => er?.er_code === 'GATE_PTY' && er?.er_pos === gate?.pos);
            const colorBackground = pty?.er_value === '-' ? 'bg-success' : pty?.er_value === '2' ? 'bg-warning' : pty?.er_value === '50' ? 'bg-danger' : 'bg-white';
            return (<td className={`border text-center bg-success ${colorBackground} ${displayArr[Number(gate?.pos)]}`} key={gate?.pos} >{pty?.er_value ? pty?.er_value : ''}</td>);
        })
    }</>

    let colSpan = 1;
    const splitTimes = <>{
        gates?.map((gate, colIndex) => {
            let split = splits?.find(splt => splt?.value === gate?.pos);
            if (split) {
                const splitLabel = <Label data={split?.extension?.find(e => e?.code === 'NAME')?.value} />;
                const time = res?.extendedResults?.find(er => er?.er_code === 'INTERMEDIATE' && er?.er_pos === split?.pos);
                const out = (<td colSpan={colSpan} className={`text-center border-end fw-bold ${displayArr[Number(colIndex)]}`} key={split?.pos} >{splitLabel}: {time?.er_value ? time?.er_value : ''}</td>);
                colSpan = 1;
                return out;
            } else if (gate?.pos == totalGates) {
                return (<td colSpan={colSpan} className={`text-center ${displayArr[Number(colIndex)]}`} key="F" ></td>);
            } else {
                colSpan++;
            }
        })
    }</>


    return <SplitResults
        gateNumbers={gateNumbers}
        gatePenalties={gatePenalties}
        splitTimes={splitTimes}
        pty={res?.pty}
        time={time}
        heat={heat}
        adjustByTotalTime={adjustByTotalTime}
        totalGates={totalGates}
        colsExtendedVisible={colsExtendedVisible}
        columnindex={columnindex}
        setColumnIndex={setColumnIndex}
        displayArr={displayArr}
        showNavBar={showNavBar} />;
}



export const SplitResults = (props) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const { gateNumbers, gatePenalties, splitTimes, pty, time, heat, adjustByTotalTime, totalGates, colsExtendedVisible, columnindex, setColumnIndex, displayArr, showNavBar } = props
    const hideLastCell = adjustByTotalTime !== 1;
    return <>
        <table className="table">
            {heat && <caption className=" fw-bold"><Label data="LabelStartTime" />: {time.substring(0, 5)} </caption>}
            <tbody>
                <tr>
                    <td className={"w-10 text-start border-bottom-0 fw-bold"}><Label data="LabelGate" /></td>
                    {gateNumbers}
                    <td className={hideLastCell ? `w-5 text-center border fw-bold fw-bold d-none` : `w-5 text-center border fw-bold fw-bold ${displayArr[totalGates + 1]}`} columnindex={totalGates + 1}><Label data="HeaderTotal" sport={mirs_discipline}/></td>
                    <td className={showNavBar ? "text-start w-5 align-text-top" : "d-none"} rowSpan={3}>
                        <NavbarSplits
                            index={columnindex}
                            setColumnIndex={setColumnIndex}
                            colsExtendedVisible={colsExtendedVisible} />
                    </td>
                </tr>
                <tr>
                    <td className="w-10 text-start border-bottom-0 fw-bold"><Label data="HeaderPenaltySeconds" /></td>
                    {gatePenalties}
                    <td className={hideLastCell ? `w-5 text-center border fw-bold d-none` : `w-5 text-center border fw-bold ${displayArr[totalGates + 1]}`} columnindex={totalGates + 1}>{pty}</td>
                </tr>
                <tr>
                    <td className="w-10 text-start fw-bold"><Label data="HeaderSplitTimes" /></td>
                    {splitTimes}
                    <td className={hideLastCell ? `w-5 text-end d-none` : `w-5 text-end ${displayArr[totalGates + adjustByTotalTime]}`} columnindex={totalGates + adjustByTotalTime}></td>
                </tr>
            </tbody>
        </table>


    </>
}

const NavbarSplits = ({ index, setColumnIndex, colsExtendedVisible }) => {

    const handleColumnIncrement = () => {
        index = (index < colsExtendedVisible.length) ? index + 1 : index
        setColumnIndex(index)
    }

    const handleColumnDecrement = () => {
        index = (index > colsExtendedVisible.length - 1) ? index - 1 : 1
        setColumnIndex(index)
    }

    return (
        <nav>
            <button className='splits' onClick={() => handleColumnDecrement()}><FontAwesomeIcon className="font-icon" icon={faAngleLeft} /></button>
            {/*      <span>{columnindex}/{numColumns}</span>*/}
            <button className='splits' onClick={() => handleColumnIncrement()}><FontAwesomeIcon className="font-icon" icon={faAngleRight} /></button>
        </nav>
    );
};


export const getConfigData = (config, adjustByTotalTime) => {
    const gates = config?.filter(c => c?.code === 'GATE')?.sort((a, b) => (a?.pos === 'F' ? 1000 : a?.pos) - (b?.pos === 'F' ? 1000 : b?.pos));
    const totalGates = Array.isArray(gates) ? gates.length : 0;
    const splits = config?.filter(c => c?.code === 'INTERMEDIATE')?.sort((a, b) => (a?.pos === 'F' ? 1000 : a?.pos) - (b?.pos === 'F' ? 1000 : b?.pos));
    let colsExtendedVisible = []
    let colSpan = 1;
    gates.forEach((gate, i) => {
        let split = splits?.find(splt => splt?.value === gate?.pos);
        if (split) {
            colsExtendedVisible.push(colSpan)
            colSpan = 1;
        } else if (gate?.pos == totalGates) {
            colsExtendedVisible.push(colSpan + Number(adjustByTotalTime));
        } else {
            colSpan++
        }

    })
    let cumulatedColsExtendedVisible = [];
    let cumulated = 0;
    colsExtendedVisible.forEach((split) => {
        cumulated += split
        cumulatedColsExtendedVisible.push(cumulated);
    })

    return {
        gates: gates,
        splits: splits,
        totalGates: totalGates,
        colsExtendedVisible: colsExtendedVisible,
        cumulatedColsExtendedVisible: cumulatedColsExtendedVisible
    }
}

export const getsplitByPty = (splits, res) => {
    const a = res?.extendedResults?.filter(er => er?.er_code === 'GATE_PTY')?.sort((a, b) => b?.er_pos - a?.er_pos);
    const gate = a && Array.isArray(a) && a.length > 0 && !isNaN(a[0]?.er_pos) ? Number(a[0]?.er_pos) : 1;
    let out = 1
    if (gate !== 1) {
        splits.forEach((max, i, all) => {
            let min = i > 0 ? all[i - 1] : 1;
            if (min < gate && gate < max) {
                out = i + 1
            }
        })
    }
    return out
}
